import Vue from 'vue'
import teReo from '../mixins/teReo'

const factSheet = new Vue({
  el: '#fact-sheet',
  mixins: [
    teReo
  ]
})
